import { render, staticRenderFns } from "./Onboarding_admin.vue?vue&type=template&id=442359ea"
import script from "./Onboarding_admin.vue?vue&type=script&lang=js"
export * from "./Onboarding_admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports